import keyMirror from 'keymirror';

export default keyMirror({
  SELECT_SERVICE: null,
  REQUEST_SERVICES: null,
  RECEIVE_SERVICES: null,
  SET_SERVICE_EXISTENCE: null,
  ERROR_RECEIVE_SERVICES: null,
  SHOW_ALL_SERVICES: null,
  UPDATE_SERVICE_TYPE: null,
  CATEGORIZE_SERVICES: null,
  STOP_FETCHING: null,
  SUGGESTED_SERVICES_REQUEST: null,
  SUGGESTED_SERVICES_SUCCESS: null,
  SUGGESTED_SERVICES_ERROR: null,
  SET_SELECTED_SERVICE: null
});
